"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CATALOG_NAME_BY_ID = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_CATALOG_NAME_BY_ID = (0, gql_1.gql)(`
  query catalogName($id: ID!) {
   catalogs(ids: [$id]) {
     edges {
       node {
         id
         title
       }
     }
   }
  }
`);
